import type { CountryCode } from '@/context/CountryContext';

export const COUNTRY_CITY_OPTIONS: Record<CountryCode, string[]> = {
  OM: ['مسقط', 'صلالة', 'صحار', 'نزوى', 'السيب', 'بوشر', 'صور', 'عبري'],
  SA: ['الرياض', 'جدة', 'الدمام', 'مكة', 'المدينة', 'الخبر', 'الطائف', 'تبوك'],
  AE: ['دبي', 'أبوظبي', 'الشارقة', 'عجمان', 'رأس الخيمة', 'العين', 'الفجيرة'],
  QA: ['الدوحة', 'الريان', 'الوكرة', 'لوسيل', 'الخور', 'أم صلال'],
  KW: ['مدينة الكويت', 'حولي', 'السالمية', 'الفروانية', 'الأحمدي', 'الجهراء'],
  SD: ['الخرطوم', 'أم درمان', 'بحري', 'بورتسودان', 'مدني', 'كسلا'],
};

export function getCitiesForCountry(countryCode?: CountryCode): string[] {
  return COUNTRY_CITY_OPTIONS[countryCode || 'OM'] || COUNTRY_CITY_OPTIONS.OM;
}
